import { createFileRoute } from '@tanstack/react-router'
import { CargoRedirect } from '../../../../src/pages/PICC/CargoRedirect'
import { PERMISSION_ROLES } from '../../../../src/constants/premissions'
import { piccCargoRedirectParamsSchema, piccCargoRedirectSearchSchema } from '../../../../src/schemas/routeSchemas'
import { requirePermission } from '../../../../src/utils/routePermissions'

export const Route = createFileRoute('/picc/cargo-redirect/$url')({
  validateSearch: (search) => piccCargoRedirectSearchSchema.parse(search),
  params: {
    parse: (params) => piccCargoRedirectParamsSchema.parse(params),
  },
  loaderDeps: () => ({}),
  beforeLoad: ({ context }) => {
    requirePermission(context, Route.options.staticData?.permissionRequired)
  },
  staticData: {
    englishAllowed: true,
    permissionRequired: PERMISSION_ROLES.PICC_CARGO_REDIRECT,
  },
  component: PiccCargoRedirectComponent,
})

function PiccCargoRedirectComponent() {
  const { url } = Route.useParams()

  return <CargoRedirect url={url} />
}
